/**
 * Tuning values for every card effect (balance lives here, not inline).
 * Power policy (docs/12 D3): commons ~5%, rares ~10%, the +20% pieces are
 * epic AND low-weighted — big jumps must stay very rare.
 * Per-stat math (docs/12 H5): valuable stats grow in SMALL steps.
 */
export const CARD_VALUES = {
  damage: 1.04,
  fireRate: 1.05,
  catDamage: 1.05,
  catFireRate: 1.05,
  speed: 1.04,
  magnet: 1.15,
  projSpeed: 1.06,
  range: 1.08,
  dashCooldown: 0.94,
  greed: 1.08,
  discount: 0.96,
  critChance: 0.03,
  critDamage: 0.15,
  supershot: 1.1,
  iframes: 1.15,
  overcharge: 1.12,
  ghostIframes: 0.25,
  lifesteal: 0.02,
  apexCritChance: 0.05,
  apexCritDamage: 0.25,

  // Trade-off cards (docs/12 C2): the boost is ~2× a plain card of the same
  // stat — paid for by a real downside. Up/down values per card:
  // Defense expansion (docs/12 C5)
  bulwark: 0.96,
  aegis: { ratio: 0.5, cap: 0.25 },

  glasscannon: { damage: 1.1, iframes: 0.85 },
  hairtrigger: { fireRate: 1.1, range: 0.92 },
  heavyplating: { speed: 0.93 },
  boosterrig: { speed: 1.1, damage: 0.97 },
  lootballast: { greed: 1.18, speed: 0.96 },
} as const;
